/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListMembersStatus = typeof ListMembersStatus[keyof typeof ListMembersStatus] | null;


export const ListMembersStatus = {
  active: 'active',
  inactive: 'inactive',
} as const;
